export const pagePaddingX = { xs: 2, sm: 3, md: 4 };
export const pagePaddingY = { xs: 2, sm: 3 };
export const layoutPaddingY = { xs: 3, sm: 5 };
